/** `?compare=1` on a review link: open the review into its version comparison. */
export function parseCompareSearch(search: Record<string, unknown>): {
  compare?: true;
} {
  const value = search.compare;
  return value === true || value === 1 || value === "1" || value === "true"
    ? { compare: true }
    : {};
}
